/*
 * Filename: author.js
 * By: J. Nguyen
 * Date: 1/5/22 
 *
 *
 */

// Modules Used On Page
import ReadMore from '../modules/read-more.js';   

const defaults = {             
  debugMode: false
}

// DOM NODES
const readMoreNodes = document.getElementsByClassName('read-more');

init();
 
// initilize the module
function init() {
  
  // setup read more elements
  for (let x = 0; x < readMoreNodes.length; x++) {
    ReadMore( readMoreNodes[x] );
    debug('init Read More nodes');
  }
}



// Basic debug function
function debug(msg) { 
  if (defaults.debugMode) {
    console.log(msg);
  }
}

